import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { push } from "react-router-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import PartnerData from "./Data";
import { apiUrls, formLink } from "./init";

const { api } = adminAPI.actions;

const AddPartner = (props) => {
  const dispatch = useDispatch();

  const [partner, setPartner] = useState({});

  const saveHandler = (req, res) => {
    res.onSuccess = (body) => {
      dispatch(push(formLink(body)));
    };
    props.addUser(req, res);
  };

  const [openModal, setOpenModal] = useState(false);
  const toggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    setPartner({});
  }, [openModal]);

  return (
    <>
      <i className="fa fa-plus" onClick={toggleModal} />
      {openModal && (
        <Modal isOpen={openModal} centered size="md" toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <IntlMessages id={"Partners.Add"} />
          </ModalHeader>
          <ModalBody>
            <PartnerData {...{ partner, setPartner, saveHandler }} />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default connect(null, {
  addUser: api.post(apiUrls.list),
})(AddPartner);
